import React from 'react';
import './FullScreenLoader.css';

function FullScreenLoader() {
  return (
    <div className="fullscreen-loader">
      <div className="loader-spinner"></div>
      <p>Loading...</p>
    </div>
  );
}

export default FullScreenLoader;
